<template>
  <modal name="cardDeckCollaborationsConfirmationModal" height="auto" width="500px" :scrollable="true">
    <div class="modal-content">
      <div class="modal-header d-flex flex-column">
        <div class="w-100 text-center" style="position: relative">
          <inline-svg class="mb-2" src="/assets/img/icons/check-circle.svg"></inline-svg>
          <button type="button" class="btn-close btn-close-absolute" data-dismiss="modal" aria-hidden="true"
                  @click="$modal.hide('cardDeckCollaborationsConfirmationModal')"></button>
        </div>
        <h4 class="modal-title">Shared with you team</h4>
        <div class="modal-subtitle-gray text-center">Now they can collaborate on this Card Deck</div>
      </div>
      <div class="d-flex flex-column gap-2 p-3 mt-2" >
        <div class="d-flex flex-row justify-content-between gap-2">
          <btn class="btn-outline-light btn-lg flex-1" @click="$modal.hide('cardDeckCollaborationsConfirmationModal')">
            Understood
          </btn>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>

export default {
    name: "CardDeckCollaborationsConfirmationModal",
}
</script>
